export const PRODUCT_IMAGE_OPTION_ERROR = "Please select a product image to generate a background";

export const IMAGE_GENERATED_BACKGROUND = "Product image placed with a generated background";
export const FULLY_GENERATED_IMAGE = "Fully generated image";

export const PRODUCT_PLACEMENT_CONSTANTS = {
  LABEL: "Type of image to generate:",
  OPTIONS: [
    { id: FULLY_GENERATED_IMAGE, label: FULLY_GENERATED_IMAGE },
    { id: IMAGE_GENERATED_BACKGROUND, label: IMAGE_GENERATED_BACKGROUND },
  ],
  SELECT_BUTTON_NAME: "Select product image",
  CHANGE_BUTTON_NAME: "Change product image",
};
